var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"id":_vm.id,"type":"date","state":_vm.state},on:{"change":_vm.onChanged},model:{value:(_vm.textDate),callback:function ($$v) {_vm.textDate=$$v},expression:"textDate"}})}
var staticRenderFns = []

export { render, staticRenderFns }